(function () {
  var KEY = 'wishlist_items';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  function toggle(handle) {
    var list = get(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    save(list);
  }

  function paint() {
    var list = get();
    document.querySelectorAll('.wl-btn').forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on);
      b.textContent = on ? '♥' : '♡';
    });
    document.querySelectorAll('.wl-count').forEach(function (c) { c.textContent = list.length; });
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
  }

  function renderPage() {
    var box = document.getElementById('wishlist-page');
    if (!box) return;
    var list = get();
    if (!list.length) { box.innerHTML = '<p>Your wishlist is empty.</p>'; return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; });
    })).then(function (items) {
      box.innerHTML = '<div class="wl-grid">' + items.filter(Boolean).map(function (p) {
        return '<div class="wl-item"><a href="' + p.url + '"><img src="' + p.featured_image + '" alt=""><h3>' +
          p.title + '</h3><p>' + money(p.price) + '</p></a>' +
          '<button class="wl-btn active" data-handle="' + p.handle + '">♥</button></div>';
      }).join('') + '</div>';
      paint();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.wl-btn');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.dataset.handle);
    paint();
    renderPage();
  });

  var css = '.wl-btn{background:none;border:0;font-size:24px;cursor:pointer;line-height:1}' +
    '.wl-btn.active{color:#c0392b}' +
    '.wl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:24px}' +
    '.wl-item{position:relative}.wl-item img{width:100%;height:auto}' +
    '.wl-item .wl-btn{position:absolute;top:8px;right:8px}';
  var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);

  document.addEventListener('DOMContentLoaded', function () { paint(); renderPage(); });
})();
(function () {
  var tries = 0;
  function addHeart() {
    if (document.querySelector('.wl-header')) return true;
    var el = document.querySelector(
      'header cart-icon, header a[href*="/cart"], header [aria-controls*="cart"], header [aria-label*="art" i]'
    );
    if (!el) return false;
    var spot = el.closest('a, button, cart-drawer-component') || el;
    var a = document.createElement('a');
    a.href = '/pages/wishlist-page';
    a.className = 'wl-header';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-4.6-9.3-9.1C1.2 8.9 2.7 5 6.3 5c2 0 3.2 1.1 3.7 2 .5-.9 1.7-2 3.7-2 3.6 0 5.1 3.9 3.6 6.9C19 16.4 12 21 12 21z"/></svg>';
    spot.parentNode.insertBefore(a, spot);
    return true;
  }
  var timer = setInterval(function () {
    if (addHeart() || ++tries > 20) clearInterval(timer);
  }, 250);
})();
(function () {
  function enhance() {
    document.querySelectorAll('#wishlist-page .wl-item').forEach(function (item) {
      if (item.dataset.cartReady) return;
      var heart = item.querySelector('.wl-btn');
      if (!heart) return;
      item.dataset.cartReady = '1';
      fetch('/products/' + heart.dataset.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var anyAvailable = p.variants.some(function (v) { return v.available; });
          var box = document.createElement('div');
          box.className = 'wl-cart';
          var html = '';
          if (p.variants.length > 1) {
            html += '<select class="wl-variant">' + p.variants.map(function (v) {
              return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
                v.title + (v.available ? '' : ' (sold out)') + '</option>';
            }).join('') + '</select>';
          }
          html += '<button type="button" class="wl-add"' + (anyAvailable ? '' : ' disabled') + '>' +
            (anyAvailable ? 'Add to cart' : 'Sold out') + '</button>';
          box.innerHTML = html;
          item.appendChild(box);

          var add = box.querySelector('.wl-add');
          add.addEventListener('click', function () {
            if (add.dataset.done) { window.location.href = '/cart'; return; }
            var sel = box.querySelector('.wl-variant');
            var id = sel ? sel.value : p.variants[0].id;
            add.textContent = 'Adding...';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
            }).then(function (r) {
              if (!r.ok) throw new Error('fail');
              add.textContent = 'Added ✓ Go to cart';
              add.dataset.done = '1'; if (window.wlRefreshCart) window.wlRefreshCart();
            }).catch(function () {
              add.textContent = 'Try again';
            });
          });
        });
    });
  }
  var box = document.getElementById('wishlist-page');
  if (!box) return;
  new MutationObserver(enhance).observe(box, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', enhance);
})();
(function () {
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var tries = 0;

  function saved() {
    try { return (JSON.parse(localStorage.getItem('wishlist_items')) || []).indexOf(handle) > -1; }
    catch (e) { return false; }
  }

  function addHeart() {
    if (document.querySelector('.wl-pdp')) return true;
    var btn = document.querySelector(
      'form[action*="/cart/add"] [type="submit"], product-form [type="submit"], button[name="add"]'
    );
    if (!btn) return false;
    var on = saved();
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wl-btn wl-pdp' + (on ? ' active' : '');
    b.dataset.handle = handle;
    b.setAttribute('aria-label', 'Add to wishlist');
    b.setAttribute('aria-pressed', on);
    b.textContent = on ? '♥' : '♡';
    btn.parentNode.insertBefore(b, btn.nextSibling);
    return true;
  }

  var timer = setInterval(function () {
    if (addHeart() || ++tries > 20) clearInterval(timer);
  }, 250);
})();
window.wlRefreshCart = function () {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var n = cart.item_count;
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: { resource: cart, sourceId: 'wishlist', data: { source: 'wishlist', itemCount: n } }
      }));
      document.querySelectorAll('header [class*="cart-bubble__text-count"], header [class*="cart-count"]').forEach(function (el) {
        el.textContent = n;
      });
    });
};